import React, { useMemo } from "react";
import {
  PROFILE_FAV_SPORT_GRID_OPTIONS,
  favSportIcon,
  type ProfileFavSportOption,
} from "./profileFavSportIcons";

const LIME = "#D2FF00";

type Props = {
  selected: readonly string[];
  onToggle: (sport: ProfileFavSportOption) => void;
};

export function ProfileFavouriteSportsGrid({ selected, onToggle }: Props) {
  const selectedSet = useMemo(() => new Set(selected), [selected]);

  return (
    <div className="w-full min-w-0 pb-3 sm:pb-5">
      <div className="pt-3 pb-5 sm:pt-4 sm:pb-6">
        <p className="text-center font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none]">
          Favourite Sports
        </p>
      </div>
      <div className="mx-auto grid w-max max-w-full grid-cols-[repeat(4,70px)] justify-items-center gap-x-4 gap-y-3 sm:gap-x-5 sm:gap-y-4">
        {PROFILE_FAV_SPORT_GRID_OPTIONS.map((sport) => {
          const isSelected = selectedSet.has(sport);
          const color = isSelected ? LIME : "#FFFFFF";
          return (
            <button
              key={sport}
              type="button"
              onClick={() => onToggle(sport)}
              aria-pressed={isSelected}
              aria-label={sport}
              className={`flex h-[70px] min-h-[70px] w-[70px] min-w-[70px] shrink-0 flex-col items-center justify-center gap-1 overflow-hidden rounded-none border-[3px] px-0.5 py-1 transition-colors ${
                isSelected
                  ? "border-[#D2FF00] bg-[#8255BE]"
                  : "border-transparent bg-white/10 hover:bg-white/[0.14]"
              }`}
            >
              <span className="flex shrink-0 items-center justify-center">
                {favSportIcon(sport, color, "mx-auto h-[24px] w-[24px] shrink-0")}
              </span>
              <span
                className={`w-full min-w-0 shrink-0 px-0.5 text-center font-anton text-[10px] font-normal not-italic uppercase leading-[16px] tracking-normal [leading-trim:none] ${
                  sport === "Horse Racing" ? "mt-1 whitespace-nowrap" : "line-clamp-2"
                } ${isSelected ? "text-[#D2FF00]" : "text-white"}`}
              >
                {sport}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
